
































import Vue from 'vue';

export default Vue.extend({
  auth: true,
  data: () => ({
    documents: {},
  }),
  computed: {
    tenant() {
      return this.$route.params.tenant;
    },
    workspace() {
      return this.$route.params.workspace;
    },
    columns(): any {
      return [
        { value: this.$t('page.download.table.date'), field: 'createdOn', format: (createdOn: string) => this.$format.localDate(createdOn) },
        { value: this.$t('page.download.table.name'), field: 'subject' },
      ];
    },
  },
  mounted() {
  },
  methods: {
    async populateMyDocumentList() {
      const response = await this.$service.api.memberDocuments.getMyDocuments();
      return response;
    },
    navigateBackToOverview() {
      this.$router.push('/syna/memberPortal/downloads');
    },
  },
});
